/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DisablePaycheckAllocationRequest} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'
import {DisablePaycheckAllocationResponse} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'


export const disablePaycheckAllocation = (request:DisablePaycheckAllocationRequest, options?: CashRequestOptions) => post<DisablePaycheckAllocationRequest, DisablePaycheckAllocationResponse>("/2.0/cash/disable-paycheck-allocation", request, {...options, rejectOnError: true })